export default __webpack_public_path__ + "9ea5ddb5a607d6612152bce379caa4f3.png";